import { render, staticRenderFns } from "./BookingsView.vue?vue&type=template&id=37919b2d"
import script from "./BookingsView.vue?vue&type=script&lang=ts"
export * from "./BookingsView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports